/**
 * Future booking providers for Contact « Prendre rendez-vous ».
 * Set VITE_CONTACT_BOOKING_URL to enable an external scheduler (Bookings / Calendly).
 * When unset, the UI falls back to demo request on the contact form.
 */
export type ContactBookingProvider = "none" | "microsoft-bookings" | "calendly" | "external";

export interface ContactBookingConfig {
  provider: ContactBookingProvider;
  href: string | null;
}

export function resolveContactBooking(): ContactBookingConfig {
  const href =
    typeof import.meta !== "undefined" && import.meta.env?.VITE_CONTACT_BOOKING_URL
      ? String(import.meta.env.VITE_CONTACT_BOOKING_URL).trim() || null
      : null;
  if (!href) {
    return { provider: "none", href: null };
  }
  const lower = href.toLowerCase();
  const provider: ContactBookingProvider = lower.includes("bookings.microsoft")
    ? "microsoft-bookings"
    : lower.includes("calendly")
      ? "calendly"
      : "external";
  return { provider, href };
}
